export default __webpack_public_path__ + "static/media/Alexander_Stolyarov.c6672747.webp";